export const COMMON_WIDTH = '25px'

export const styles = {
  container: (tree, node) => ({
    height: tree.rowHeight,
    alignItems: 'center',
    position: 'relative',
    ...node?.data.sx,
    pl: '0px !important',
    ml: 0,
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: 'background.primary',
      borderRadius: '6px'
    },
    mr: 0,
    pr: 0,
    transition: 'background-color 140ms ease, transform 140ms ease'
  }),

  lineStack: tree => ({
    flex: `0 0 ${COMMON_WIDTH}`,
    height: tree.rowHeight,
    width: COMMON_WIDTH,
    display: 'flex'
  }),

  nodeText: ({ waiting, italic, isParent }) => ({
    pl: '5px',
    fontSize: '12px',
    lineHeight: '21px',
    fontWeight: isParent ? 400 : 300,
    color: isParent ? '#464646' : '#656565',
    textTransform: 'capitalize',
    cursor: waiting ? 'wait' : 'inherit',
    ...(italic ? {fontStyle: 'italic'} : {})
  }),

  counter: theme => ({
    border: `1px solid ${theme.palette.border.primary}`,
    borderRadius: '6px',
    padding: '2px 6px'
  }),

  counterValue: {
    color: 'primary.main',
    fontSize: '10px',
    lineHeight: '14px',
    fontWeight: 600
  },

  counterTotal: theme => ({
    color: theme.palette.text.body.tertiary,
    fontSize: '10px',
    lineHeight: '14px',
    fontWeight: 400,
    ml: 0.5
  })
}
